import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/next/dist/client/app-dir/link.js");
;
import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/next/dist/client/image-component.js");
;
import(/* webpackMode: "eager" */ "/vercel/path0/public/assets/Chee_Wei_Jie-20251104-09ba8b62.jpg");
;
import(/* webpackMode: "eager" */ "/vercel/path0/public/assets/Ezekiel_Tan-20251104-5c7bc105.png");
;
import(/* webpackMode: "eager" */ "/vercel/path0/public/assets/marcus-pang-profile-20260813-0d492886.png");
